export default class AddressService {
  static columnSettings = {
    id: {
      hide: true,
      class: 'max-width-80',
      align: 'left',
      stSort: '',
      displayName: 'ADDRESSES_ID',
      rowAlign: 'left'
    },
    name: {
      class: 'column-sortable',
      align: 'left',
      stSort: 'name',
      displayName: 'ADDRESSES_NAME',
      rowAlign: 'left'
    },
    countryCode: {
      class: 'column-sortable',
      stSort: 'countryCode',
      displayName: 'ADDRESSES_COUNTRY',
      rowAlign: 'left'
    },
    addressCombined: {
      class: 'column-sortable',
      stSort: 'streetAddress + city + region + postalCode',
      displayName: 'ADDRESSES_COMBINED',
      rowAlign: 'left'
    },
    businessName: {
      class: 'column-sortable',
      stSort: 'customerName',
      displayName: 'ADDRESSES_BUSINESS',
      rowAlign: 'left'
    }
  };

  static defaultColumns = [
    'name',
    'countryCode',
    'addressCombined',
    'businessName',
  ];

  constructor($http, ngAuthSettings, cacheService, infoService) {
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    this.$http = $http;
    this.cacheService = cacheService;
    this.infoService = infoService;
  }

  getAddresses(accountId) {
    var url = this._controllerUrl(accountId);
    return this.$http.get(url);
  }

  getAddress(accountId, addressId) {
    var url = this._serviceBaseUrl(accountId, addressId);
    return this.$http.get(url);
  }

  createAddress(accountId, address) {
    var url = this._controllerUrl(accountId);
    return this.$http.post(url, address).then(this._removeCountriesCache);
  }

  deleteAddress(accountId, addressId) {
    var url = this._serviceBaseUrl(accountId, addressId);
    return this.$http.delete(url).then(this._removeCountriesCache);
  }

  updateAddress(accountId, address) {
    var url = this._serviceBaseUrl(accountId, address.id);
    return this.$http.patch(url, address).then(this._removeCountriesCache);
  }

  _removeCountriesCache(response) {
    this.infoService.clearCountriesCache();
    return response;
  }

  _controllerUrl(accountId) {
    return this.serviceBaseUri + accountId + '/addresses';
  }

  _serviceBaseUrl(accountId, addressId) {
    return this._controllerUrl(accountId) + '/' + addressId;
  }
}
